var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBadgeShield = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.66667 9.33333C2.54051 9.33376 2.41682 9.29839 2.30997 9.23132C2.20312 9.16425 2.11749 9.06824 2.06303 8.95444C2.00858 8.84064 1.98753 8.71372 2.00233 8.58844C2.01714 8.46315 2.06719 8.34464 2.14667 8.24667L8.74667 1.44667C8.79617 1.38952 8.86364 1.3509 8.93799 1.33715C9.01234 1.32341 9.08915 1.33534 9.15582 1.371C9.22249 1.40666 9.27506 1.46393 9.30489 1.53341C9.33472 1.60288 9.34005 1.68043 9.32 1.75333L8.04 5.76667C8.00226 5.86768 7.98958 5.97635 8.00306 6.08334C8.01654 6.19033 8.05577 6.29245 8.11739 6.38095C8.17901 6.46945 8.26118 6.54168 8.35685 6.59144C8.45252 6.6412 8.55883 6.66702 8.66667 6.66667H13.3333C13.4595 6.66624 13.5832 6.70161 13.69 6.76868C13.7969 6.83575 13.8825 6.93176 13.937 7.04556C13.9914 7.15936 14.0125 7.28628 13.9977 7.41156C13.9829 7.53685 13.9328 7.65536 13.8533 7.75333L7.25333 14.5533C7.20383 14.6105 7.13636 14.6491 7.06201 14.6628C6.98766 14.6766 6.91085 14.6647 6.84418 14.629C6.77751 14.5933 6.72494 14.5361 6.69511 14.4666C6.66528 14.3971 6.65995 14.3196 6.68 14.2467L7.96 10.2333C7.99774 10.1323 8.01042 10.0237 7.99694 9.91666C7.98346 9.80967 7.94423 9.70755 7.88261 9.61905C7.82099 9.53055 7.73882 9.45832 7.64315 9.40856C7.54748 9.3588 7.44117 9.33298 7.33333 9.33333H2.66667Z",
    stroke: "#432DD7",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBadgeShield);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-badge-shield.00f68cbbdd3bbe9c5d417507e07a0b85.svg";